import { useState, useEffect } from 'react'
import { getSimpleStudyList } from '../api/studyListApi'
import { getCommercialProducts } from '../api/commercialProducts'
import { getDevelopmentStatuss } from '../api/developmentStatuss'
import { getSimpleConditions } from '../api/conditions'
import { getSimpleInterventions } from '../api/interventions'
import { getValuesForReactSelect } from './formUtils'

const useReferenceData = (studyId) => {
  const [simpleStudyList, setSimpleStudyList] = useState(null)
  const [studyListOptions, setStudyListOptions] = useState(null)
  const [relatedStudyOptions, setRelatedStudyOptions] = useState(null)
  const [commercialProducts, setCommercialProducts] = useState(null)
  const [developmentStatuses, setDevelopmentStatuses] = useState(null)
  const [conditionOptions, setConditionOptions] = useState(null)
  const [interventionOptions, setInterventionOptions] = useState(null)

  useEffect(() => {
    getSimpleStudyList().then((res) => {
      setSimpleStudyList(res)
      const allOptions = res.map(study => ({
        value: study.id, label: study.org_study_id
      }))
      setStudyListOptions(allOptions)
      const relatedOptions = allOptions.filter(
        study => Number(study.value) !== Number(studyId)
      )
      setRelatedStudyOptions(relatedOptions)
    })
    getCommercialProducts().then((res) => {
      setCommercialProducts(res.map(element => ({
        id: String(element.id),
        name: element.name,
        additional_info: element.additional_info
      })))
    })
    getDevelopmentStatuss().then((res) => {
      setDevelopmentStatuses(res.map(element => ({
        id: String(element.id),
        name: element.name,
        additional_info: element.additional_info
      })))
    })
    getSimpleConditions().then((res) => {
      setConditionOptions(getValuesForReactSelect(res))
    })
    getSimpleInterventions().then((res) => {
      setInterventionOptions(getValuesForReactSelect(res))
    })
  }, [])

  return {
    simpleStudyList,
    studyListOptions,
    relatedStudyOptions,
    commercialProducts,
    developmentStatuses,
    conditionOptions,
    interventionOptions,
  }
}

export default useReferenceData
